<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Certifikati predelovalca</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
      <div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            /> 
              <predelovalec :predelovalec="predelovalec">
          </predelovalec>
            
            
          </div>
        </div>
      
    <div class="uporabnik-spacer" style="margin-top:2rem"></div>
    <Grid  
                       
                      
                        :data-items="gridData"
                        :columns="columns"
                          @datastatechange="dataStateChange"
                       
                       :edit-field="'inEdit'"
                        @itemchange="itemChange"

                        
                         :row-render="rowRenderFunction"
                      
                        

                         
                        
                                               >
                                               <template v-slot:certifikatLink="{props}">
                    <td>
                      <a
                        class="k-primary k-button k-grid-edit-command" v-if="props.dataItem.id >= 0 && props.dataItem.jeaktivna"
                        :href="'/interno/certifikatp/'+props.dataItem.id" target="_blank" title="Poglej">
                         <font-awesome-icon icon="certificate"/> &nbsp;
                         
                    </a>
                </td></template>
                  
                    <template v-slot:shranigumb="{props}">
                        <td>
                              <div class="km-widget km-buttongroup k-widget k-button-group">
                      <button
                             :disabled="editDisabled"
                                title="Shrani certifikat"
                                class="k-button k-primary"
                                @click="shraniCertifikat(props.dataItem)"
                            >
                                <span v-if="!props.dataItem.jeaktivna">Povrni</span>
                                <span v-else>Shrani</span>
                            </button>
                         <button
                             :disabled="!props.dataItem.jeaktivna"
                                title="Briši certifikat"
                                class="k-button k-primary"
                                @click="brisiCertifikat(props.dataItem)"
                            >
                                Briši
                            </button>
                       
                        </div>
                        </td>
                    </template>
                    <template v-slot:statusshranjevanja="{props}">
                        <td>
                             <span title="Status shranjevanja" v-if="props.dataItem.saved!=undefined" :class="[props.dataItem.saved?'action_success':'action_error','k-badge','k-badge-solid','k-badge-md','k-badge-pill']">
                        <font-awesome-icon v-if="props.dataItem.saved" icon="check" class='action_success'/> 
                        <font-awesome-icon v-else icon="times"/> 
                        </span> 
                        </td>
                    </template>
                 <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                           <!--
                           <button
                                title="Omogoči urejanje"
                                class="k-button k-primary"
                               
                            >
                                Omogoči urejanje
                            </button>
                          -->
                        <button :disabled="editDisabled"
                                title="Dodaj"
                                class="k-button k-primary"
                                @click="insert">
                                Dodaj certifikat
                        </button>
                      
                        
                            
                            
                                 <button class="k-button k-primary"  title="Nazaj" @click="nazaj" >Nazaj</button>
                            
                            <!--
                        <button
                                title="Export to Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                        <button
                                title="Obrazec za površine"
                                class="k-button k-primary"
                                @click="kontrolniList"
                            >
                                Obrazec za površine
                            </button>
                          -->
                        </div>
                            
                        </toolbar>
                         <GridNoRecords >
                    <div v-if="dataLoading" class="k-loading-mask loadingIconSpace">
                      <span class='k-loading-text'></span>
                      <div class='k-loading-image'></div>
                      <div class='k-loading-color'></div>
                      
                    </div>
                    <div v-else>
                      Ni podatkov!
                    </div>
                    </GridNoRecords>
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import '@progress/kendo-ui' // This will import the entire Kendo UI library
// As an alternative, you could import only the scripts that are used by a specific widget:
// import '@progress/kendo-ui/js/kendo.treelist' // Imports only the TreeList script and its dependencies

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
//import { TreeList, TreeListInstaller } from '@progress/kendo-treelist-vue-wrapper'
import sifrantKulture from './support/kulture-data';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
import SifrantKulturDownCell from './support/SifrantKulturDropDown';
import PredelovalecKratko from './support/PredelovalecKratko';
//import { sifrantService } from '../services';


//import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
//import numbers from 'cldr-numbers-full/main/es/numbers.json';
//load(
    //likelySubtags,
    //numbers);

import { process } from '@progress/kendo-data-query';
import moment from 'moment'




//Vue.component('Grid', Grid);
//Vue.component('toolbar', GridToolbar);

//var kulture=[{id:1,kulturaid:1,naziv:"A",povrsina:"1",kolicina:"2",enota:"kg",datumdolocitvestatusa:new Date(),datumveljavnostistatusa:null,status:""},
             //{id:2,kulturaid:1,naziv:"B",povrsina:"2",kolicina:"3",enota:"kg",datumdolocitvestatusa:null,datumveljavnostistatusa:null,status:""}
              //];
              var kulture=[];


export default {
  components:{
        'ukaznigumbiknt': StatusCommandCell,
     
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
       'predelovalec':PredelovalecKratko
  },
  props:['sezona','predelovalecid'],
    data () {
        return {
            //defaultItemSezona: { sezona: 'Izberi sezono...'},
            sifrantTree:{},
            dataLoading:false,
            
            dataSezona:this.sezona,
           
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            columns: [
            //    { field: "ime", title:"Ime",editable:false,width: "150px"},
                //{ field: "kmgmid", title:"KMG-MID",editable:false,width: "150px"},
                //{ field: "naslov", title:"Naslov",editable:false,width: "250px"},

                //{ field: "postnastevilka", title:"Pošta",editable:false,width: "130px"},
                //iz idja naložit šifro
                { field: "stevilkacertifikata", title:"Številka",width: "130px"},
                { field: "datumizdaje", title:"Datum izdaje", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "datumveljavnosti", title:"Datum veljavnosti", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "informacije", title:"Informacije",},
                { field: "veljaven", title:"Veljaven", editor: 'boolean',width: "70px", cell:this.veljavenIcon,validation: { required: true}},
                { title: "Poglej certifikat", cell: 'certifikatLink',filterable:false,columnMenu: null,width:"120px",sortable:false},
                //{ cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
                { title: "Shrani/Briši", cell: 'shranigumb', hidden:this.editDisabled,width:"140px",sortable:false },
                { title:'Shranjen', cell: 'statusshranjevanja',  hidden:this.editDisabled,width:"80px",sortable:false },
              
                //  { field: "status", title:"Status", cell:StatusCell},
                //gerk view link http://rkg.gov.si/GERK/WebViewer/#query=GERK_SDO:GERK_PID:4605424
                //kmg view
                //http://rkg.gov.si/GERK/WebViewer/#KMG=100735069
                //{ field: 'stanje', title: '', cell: this.cellFunction },
               // { field: "statuspridelovalca", title:"Status",editable:false,width: "200px"},
                //{ field: "kontrolnaorganizacija", title:"V kontroli pri",editable:false,width: "200px"},
                //{ field: "jeaktivna", title:"Aktivna",editable:false,filter:'boolean',width: "100px"},
                
                
                //{ field: "pisanje", title:"Dovoli pisanje",editor: 'boolean',filter:'boolean',width: "150px" },
                //{ cell: CommandCell, width: '180px',filterable:false }
            ],
          

           

        }
    },
      computed: {

        //...mapState('sifrant', ['sifrant']),
        editDisabled(){
          return (this.predelovalec.pisanje==0)
        },
        ...mapState({gridData(state) {
         // console.log(state.kultura);
         //make editable?
          return state.certifikatPredelava.certifikatPredelava;
        }}),

        ...mapState('predelava', ['predelovalec']) ,
        ...mapState('sifrant', ['sifrant']) ,
        ...mapState('users',['sezonePisanje']),

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
      
           },
    created () {

      //potegni šifrant iz sifrantstore
     /* var groupedAreas = [];
dataItems.map(function(d) {
  if(groupedAreas.filter(function(item, i) {
   return item.areaName === d.AreaName; 
  }).length === 0) {
    groupedAreas.push({ areaName: d.AreaName, subsidiaries:  dataItems.filter(function(r) { return r.AreaName === d.AreaName; }) });
  }
});*/
this.dataSezona={sezona:this.sezona};
this.naloziPodatke();

      
    },
  


    methods: {
        ...mapActions('certifikatPredelava', ['load','save','saveCert']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('certifikatPredelava',['update',"add","remove","makeEditable",'replace']),
        ...mapActions('predelava', ['loadIdPoSezoni','loadOne']),
        //...mapActions('sifrant', ['load']),
         veljavenIcon: function (h, defaultElement , props, listeners ) {
            if(props.dataItem.inEdit)
                return defaultElement;

            let veljaven=h('font-awesome-icon',{props:{icon:"times"}});
            if(props.dataItem.veljaven)
                veljaven=h('font-awesome-icon',{props:{icon:"check"}},{class:{"action_success":true}});
            let veljavenWrapper=h('span', {class:{
                'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!props.dataItem.veljaven,"action_success":props.dataItem.veljaven}}, [veljaven]);
            return h('td', {attrs:{colspan:1}}, [veljavenWrapper]);
        },
        rowRenderFunction: function (h, trElement , defaultSlots, props ) {
            console.log(trElement);
            console.log(props.dataItem);
            if(props.dataItem.jeaktivna!=1)
            trElement.data.class+=" deleted_element";

                return trElement;
            },
            shraniCertifikat: function(certifikat) {
            certifikat.jeaktivna=1;
            this.saveCert({certifikat:certifikat});
        },
        brisiCertifikat: function(certifikat) {
            certifikat.jeaktivna=0;
            this.saveCert({certifikat:certifikat});
        },
        naloziPodatke: function(){
          this.dataLoading=true;
        this.replace([]);
          this.loadOne({sezona:this.dataSezona.sezona,predelovalecid:this.predelovalecid}).then(()=>{
        

        this.load({sezona:this.dataSezona.sezona,predelovalecid:this.predelovalecid,makeEditable:!this.editDisabled}).then(

          data=>{this.dataLoading=false;},


          error=>{console.log("tukaj sem!!!");this.dataLoading=false;});
        });
      
        },
        
        itemChange: function (e) {
            //const updatedData  = this.gridData.slice();
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          e.dataItem[e.field] = e.value;
          if(e.field=="veljaven")
            e.dataItem[e.field]=e.value?1:0;
          
         //   const item = this.update(e.dataItem);
            //item[e.field] = e.value;
            //this.repalce(updatedData);
        },
         insert() {
            const dataItem = { inEdit: true,jeaktivna:1,
                  datumveljavnosti:new Date(this.dataSezona.sezona*1+1,11,31),datumizdaje:new Date(),veljaven:1,sezona:this.dataSezona.sezona,predelovalecid:this.predelovalecid                
                               
                   };
            //const newproducts = this.gridData.slice();
            //newproducts.unshift(dataItem);
            this.add(dataItem);
          //  this.repalce(newproducts);
        },
        edit: function (e) {
          //console.log(e);
            console.log(e.dataItem)
            e.dataItem.inEdit = true;
            e.dataItem.jeaktivna = 1;
            
            this.update(e.dataItem);
            console.log(this.kultura);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
                dataItem[value]=dataItem.oldValues[value];
            }
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
          console.log(e.dataItem);
          for (const value in e.dataItem.newValues){
            e.dataItem[value]=e.dataItem.newValues[value];
          }
           e.dataItem.inEdit = undefined;
             e.dataItem.jeaktivna = 1;
          //  const data = this.gridData.slice();
            this.update(e.dataItem);
            //e.dataItem.id = this.update(kulture, e.dataItem).id;
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            //this.update(this.gridData, e.dataItem, true);
            e.dataItem.jeaktivna=e.dataItem.jeaktivna?0:1;
            this.update(e.dataItem);

            //this.remove(e.dataItem);
            //console.log(this.gridData);
            //this.replace(this.gridData.slice());
        },
     nogaVsotaPovrsin: function (h, emptyElement , props, listeners ) {
          if(this.kulture)
            return h('span', {}, ['Vsota površin: ' + this.kulture.reduce((acc, current) => acc+=current.povrsina, 0).toFixed(2)+ ' ha']);
        },
     nogaVsotaKolicin: function (h, emptyElement , props, listeners ) {
          if(this.kulture)
            return h('span', {}, ['Vsota količin: ' + this.gerk.reduce((acc, current) => acc+=current.povrsina, 0).toFixed(2)]);
        },
    

       sezonaChange(event) {
             const sezona = event.value;
            this.dataSezona=sezona;
            this.loadIdPoSezoni({sezona:sezona.sezona,subjid:this.predelovalec.subjid}).then(predelovalec=>{
              this.predelovalecid=predelovalec.id;
             this.$router.push({ name: 'certifikatPredelava', params: {sezona:sezona.sezona,predelovalecid:predelovalec.id} });
             this.naloziPodatke();
              });



        },
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
                 //  console.log(this.skip);
            this.dataResult = process(this.gerk, {});
           // console.log(this.dataResult);

        },
      
        shraniKulture () {
          //  this.$router.go(-1);
          //console.log(this.dataResult);
        

              this.save();
      //         this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid});

                     
        },
       
        /*
        changeStatus: function (e) {
            console.log("Gerk change!!!");
            console.log(e.dataItem);
          //  Vue.set(e.dataItem, 'inEdit', true);
        },
*/
        //do doli
        
    }
};
</script>

